import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';
import useIsMobile from '../../../shared/hooks/useIsMobile';
import AwardSolid from '../../../shared/svg/awardSolid';
import CogSolid from '../../../shared/svg/cogSolid';
import CrownSolid from '../../../shared/svg/crownSolid';
import DumpsterSolid from '../../../shared/svg/dumpsterSolid';
import GlassesSolid from '../../../shared/svg/glassesSolid';
import IconsSolid from '../../../shared/svg/iconsSolid';
import LogoZakeke from '../../../shared/svg/logoZakekeWhite.svg';
import { Link, PrimaryButton } from '../../widgets/buttons';
import { FormControl } from '../../widgets/formControl';
import { Icon } from '../../widgets/icon';
import background from './background.png';
import Bauli from './customers/bauli.png';
import Clipper from './customers/clipper.png';
import Nau from './customers/nau.png';
import Testoni from './customers/testoni.png';
import UberEats from './customers/uberEats.png';

export const ExternalContainer = styled.div<{ $isSignup?: boolean; $isMobile?: boolean }>`
    // flex-shrink: 0;
    background: url(${background}) no-repeat center center;
    background-size: cover;
    display: ${(props) => (props.$isMobile && props.$isSignup ? 'grid' : 'flex')};
    grid-template-columns: ${(props) => (props.$isMobile && props.$isSignup ? '1fr 500px' : 'unset')};
    flex-direction: ${(props) => (props.$isMobile && props.$isSignup ? 'column' : 'row')};
    //width: 100vw;
    min-height: 100vh;
    gap: 200px;
    align-items: center;
    justify-content: center;
    padding: 10px 12%;

    @media (max-width: 1903px) {
        //min-height: 880px;
        gap: 100px;
    }

    @media (max-width: 1600px) {
        //min-height: 636px;
        gap: 50px;
        padding: 8px 6%;
        align-items: center;
        justify-content: space-between;
    }

    @media (max-width: 1024px) {
        //min-height: 768px;
        padding: 4%;
        display: flex;
        flex-direction: ${(props) => (props.$isSignup ? 'column' : 'row')};
        align-items: center;
        gap: 20px;
        justify-content: center;
    }

    @media (max-width: 998px) {
        padding: 4%;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`;

export const InternalContainer = styled.div<{ $isSignup?: boolean }>`
    display: flex;
    height: auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 80px;
    flex-shrink: 0;
    width: 60%;
    //MP
    @media (min-width: 1903px) {
        width: 740px;
    }

    @media (max-width: 1600px) {
        max-width: 634px;
        width: auto;
    }

    @media (max-width: 1024px) {
        display: block;
        align-items: center;
        width: auto;
        margin-top: ${(props) => (props?.$isSignup ? '0 ' : '24px')};
    }
`;
export const FormContainer = styled.div<{ $signUp?: boolean; $showDetails?: boolean }>`
    width: 100%;
    background: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-self: flex-start;

    @media (max-width: 1903px) {
        max-width: 100%;
        padding: 20px 40px !important;
        max-height: ${(props) => (props?.$signUp && props?.$showDetails ? '96vh ' : 'unset')};
        overflow-y: ${(props) => (props?.$signUp && props?.$showDetails ? 'auto' : 'hidden')};
    }

    @media (max-width: 1600px) {
        max-width: 100%;
        padding: 16px 40px !important;
    }

    @media (max-width: 1024px) {
        padding: 20px 22px !important;
        height: ${(props) => (props?.$signUp && props?.$showDetails ? '76vh ' : 'unset')};
        overflow-y: ${(props) => (props?.$signUp && props?.$showDetails ? 'auto' : 'hidden')};
    }
`;

const Logo = styled.div`
    width: 189.823px;
    height: 30.996px;
    margin-bottom: 20px;

    @media (max-width: 1600px) {
        width: 28%;
        height: 10%;
        margin-bottom: 20px;
    }

    @media (max-width: 1024px) {
        width: 50%;
        height: 8%;
        margin-bottom: 20px;
    }
`;

export const Title = styled.h1<{ $isSignUp?: boolean }>`
    font-size: 24px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 8px;
    color: black;

    @media (max-width: 1600px) {
        font-size: 18px;
        margin-bottom: ${(props) => (props?.$isSignUp ? '0' : '16px')};
        align-self: ${(props) => (props?.$isSignUp ? 'center' : '')};
    }

    @media (max-width: 1024px) {
        font-size: 24px;
        margin-top: 0;
        margin-bottom: 8px;
    }
`;

export const Subtitle = styled.p<{ $isHidden?: boolean }>`
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 20px;
    margin-top: 0;
    color: rgba(148, 155, 158, 1);
    line-height: 1.3;

    @media (max-width: 1600px) {
        font-size: 13px;
        display: ${(props) => (props.$isHidden ? 'none' : 'block')};
    }

    @media (max-width: 1024px) {
        font-size: 14px;
        display: block;
    }
`;

export const LandingContainer = styled.div`
    color: white;
    min-width: 0;

    @media (max-width: 1600px) {
        width: 631px;
    }

    @media (max-width: 1120px) {
        width: 550px;
    }

    @media (max-width: 1024px) {
        min-width: 320px;
        max-width: 430px;
        width: 92vw;
    }
`;

const LandingTitle = styled.h1`
    color: #fff;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    align-self: stretch;
    margin-top: 64px;

    @media (max-width: 1600px) {
        font-size: 20px;
        margin-bottom: 8px;
        margin-top: 20px;
    }

    @media (max-width: 1024px) {
        font-size: 24px;
        margin-bottom: 0px;
    }
`;

const LandingSubtitle = styled.p`
    color: #fff;
    font-size: 52px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    margin-top: 16px;
    margin-bottom: 64px;
    align-self: stretch;

    @media (max-width: 1902px) {
        font-size: 42px;
        margin-bottom: 20px;
    }

    @media (max-width: 1600px) {
        font-size: 26px;
        margin-bottom: 20px;
    }

    @media (max-width: 1024px) {
        font-size: 24px;
        margin-bottom: 10px;
        margin-top: 4px;
    }
`;

export const StyledSubmitButtonContainer = styled(FormControl)`
    margin: 32px 0 !important;

    @media (max-width: 1600px) {
        margin: 16px 0 !important;
        ${PrimaryButton} {
            padding: 6px !important;
            min-height: 6px !important;
        }
    }
`;

export const SubmitButtonContainer: FC<{
    type: string;
    disabled?: boolean;
    label: string;
    onClick?: () => void;
}> = ({ label, disabled, type, onClick }) => {
    const [buttonSize, setButtonSize] = useState<'large' | 'medium'>('large');

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth <= 1600) {
                setButtonSize('medium');
            } else {
                setButtonSize('large');
            }
        };

        window.addEventListener('resize', updateSize);
        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <StyledSubmitButtonContainer>
            {type && type == 'submit' && (
                <PrimaryButton size={buttonSize} type={'submit'} disabled={disabled ?? false}>
                    {label ?? 'Submit'}
                </PrimaryButton>
            )}
            {type && type == 'button' && (
                <PrimaryButton size={buttonSize} type={'button'} disabled={disabled ?? false} onClick={onClick}>
                    {label ?? 'Submit'}
                </PrimaryButton>
            )}
        </StyledSubmitButtonContainer>
    );
};

export const StyledSignUpButtonContainer = styled(FormControl)<{ $hideDetails?: boolean }>`
    margin: 16px 0 !important;

    @media (max-width: 1903px) {
        margin: ${(props) => (props?.$hideDetails ? '16px 0 !important ' : '0 0 16px 0!important')};
    }

    @media (max-width: 1600px) {
        margin: ${(props) => (props?.$hideDetails ? '16px 0 !important ' : '0 0 8px 0!important')};
        ${PrimaryButton} {
            padding: 6px !important;
            min-height: 6px !important;
        }
    }
`;

export const SignUpButtonContainer: FC<{
    hideDetails?: boolean;
    type: string;
    disabled: boolean;
    label: string;
    onClick?: () => void;
}> = ({ hideDetails, label, disabled, type, onClick }) => {
    const [buttonSize, setButtonSize] = useState<'large' | 'medium'>('large');

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth <= 1600) {
                setButtonSize('medium');
            } else {
                setButtonSize('large');
            }
        };

        window.addEventListener('resize', updateSize);
        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <StyledSignUpButtonContainer $hideDetails={hideDetails ?? false}>
            {type && type == 'submit' && (
                <PrimaryButton size={buttonSize} type={'submit'} disabled={disabled ?? false}>
                    {label ?? 'Submit'}
                </PrimaryButton>
            )}
            {type && type == 'button' && (
                <PrimaryButton size={buttonSize} type={'button'} disabled={disabled ?? false} onClick={onClick}>
                    {label ?? 'Submit'}
                </PrimaryButton>
            )}
        </StyledSignUpButtonContainer>
    );
};
export const SocialButton = styled.button<{ $isSignUp?: boolean }>`
    background: #f1f3f5;
    color: black;
    border: none;
    border-radius: 40px;
    cursor: pointer;
    margin-bottom: 32px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    gap: 10px;

    &:hover {
        background: #f1f3f5cc;
    }

    > img {
        width: auto;
        max-height: 24px;
        display: block;
    }

    @media (max-width: 1600px) {
        margin-bottom: 24px;
        height: 32px;
        font-size: 12px;
        gap: 6px;
        > img {
            max-height: 20px;
        }
    }

    @media (max-width: 1024px) {
        font-size: 14px;
        font-weight: 400;

        //>p{
        //	display: none;
        //}
    }
`;

// Styled Components
const ListContainer = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    list-style: none;
    padding: 0;
    column-gap: 40px;
    row-gap: 20px;

    margin-bottom: 72px;

    @media (max-width: 1600px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        margin-bottom: 32px;
    }

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin-bottom: 32px;
    }

    @media (max-width: 998px) {
        display: none;
    }
`;

const ListItem = styled.li`
    min-width: 0;
    border: 1px solid white;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    text-align: left;

    @media (max-width: 1600px) {
        padding: 12px;
        align-items: flex-start;
        gap: 10px;
    }
`;

const ListItemIcon = styled(Icon)`
    width: 52px;
    height: 52px;
    margin-bottom: 20px;

    @media (max-width: 1600px) {
        width: 40px;
        height: 40px;
        margin-bottom: 12px;
    }
`;

const ListItemTitle = styled.span`
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 16px;
    display: block;
    width: 100%;
    height: auto;

    @media (max-width: 1600px) {
        font-size: 12px;
        margin-bottom: 8px;
    }
`;

const ListItemDescription = styled.p`
    color: #fff;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    margin: 0;
    width: 100%;
    height: auto;

    @media (max-width: 1600px) {
        font-size: 10px;
        margin-bottom: 8px;
    }
`;

const Customers = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    align-self: stretch;

    > img {
        height: 38px;
    }

    @media (max-width: 1660px) {
        > img {
            height: 36px;
        }
    }

    @media (max-width: 1600px) {
        > img {
            height: 28px;
        }
    }

    @media (max-width: 1024px) {
        > img {
            height: 22px;
        }
    }

    @media (max-width: 998px) {
        display: none;
    }
`;

export const Footer = styled.ul`
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        margin: 0 10px;
    }

    ${Link} {
        text-decoration: none;
    }

    @media (max-width: 1024px) {
        margin-top: 10px;
    }
`;

export const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 50px;
    max-width: 522px;
    min-width: 522px;

    * {
        scrollbar-width: thin;
        scrollbar-color: #ccc #fff;
    }

    @media (max-width: 1600px) {
        gap: 24px;
        width: 422px;
        min-width: 380px;
        //max-height: 578px;
    }

    @media (max-width: 1024px) {
        max-width: 430px;
        min-width: 320px;
        width: 92vw;
        gap: 20px;
    }
`;

export const FieldsContainer = styled.div<{ $isSignUp?: boolean; $hideDetails?: boolean }>`
    margin: ${(props) => (props?.$isSignUp ? '0 0 16px 0' : '0 0 8px 0')};

    @media (min-width: 1903px) {
        margin: ${(props) => (props?.$isSignUp ? (props?.$hideDetails ? '0 0 16px 0' : '0') : '0 0 8px 0')};
    }

    @media (max-width: 1600px) {
        margin: ${(props) => (props?.$isSignUp ? (props?.$hideDetails ? '0 0 8px 0' : '0') : '0 0 8px 0')};
    }

    @media (max-width: 1024px) {
        margin: ${(props) => (props?.$isSignUp ? (props?.$hideDetails ? '0 0 8px 0' : '0') : '0 0 8px 0')};
    }
`;

export const FieldFormControl = styled(FormControl)`
    > label {
        font-size: 12px !important;
        height: 16px !important;
        margin-bottom: 8px !important;
    }

    &:not(:last-child) {
        margin-bottom: 18px !important;
    }

    @media (max-width: 1600px) {
        > label {
            display: none;
        }

        &:not(:last-child) {
            margin-bottom: 8px !important;
        }
    }

    @media (max-width: 1024px) {
        > label {
            display: none;
        }

        &:not(:last-child) {
            margin-bottom: 8px !important;
        }
    }
`;

export const FieldReCAPTCHAContainer = styled(FormControl)<{ $isSignup?: boolean; $hasError?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    height: 60px !important;

    > div {
        display: inline-grid !important;
        justify-items: center !important;
        gap: 8px;
    }

    > div > div > div > div > div > iframe {
        border: ${({ $hasError }) => ($hasError ? '1px solid #DE1C22 !important' : 'unset !important')};
        border-radius: ${({ $hasError }) => ($hasError ? '3px !important' : 'unset !important')};
        width: 100%;
    }

    @media (max-width: 1920px) {
        margin: ${(props) =>
            props.$isSignup
                ? props.$hasError
                    ? '20px 0 60px !important'
                    : '20px 0 35px !important'
                : props.$hasError
                  ? '32px 0 60px !important'
                  : '32px 0 42px !important'};
    }

    @media (max-width: 1600px) {
        margin: ${(props) =>
            props.$isSignup
                ? props.$hasError
                    ? '80px 0 60px !important'
                    : '80px 0 30px !important'
                : props.$hasError
                  ? '32px 0 60px !important'
                  : '32px 0 42px !important'};
    }

    @media (max-width: 1024px) {
        margin: ${(props) =>
            props.$isSignup
                ? props.$hasError
                    ? '96px 0 60px !important'
                    : '96px 0 30px !important'
                : props.$hasError
                  ? '32px 0 60px !important'
                  : '32px 0 42px !important'};
    }
`;

export const Or = styled.div<{ $isSignUp?: boolean; $text: string }>`
    margin: ${(props) => (props.$isSignUp ? '16px 0' : '32px 0')};
    width: 100%;
    text-align: center;
    color: #949b9e;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 10px;

    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #ccc;
        position: relative;
        top: 7px;
        z-index: 0;
    }

    &::after {
        content: '${(props) => props.$text}';
        display: inline-block;
        position: relative;
        background-color: white;
        z-index: 2;
        padding: 0px 20px;
    }

    @media (max-width: 1600px) {
        margin: ${(props) => (props.$isSignUp ? '0' : '16px 0')};
    }
`;

export const SocialButtonContainer = styled.div`
    margin: auto;
    width: 70%;
`;

export const LoginRegisterLayout: FC<
    PropsWithChildren<{
        bottomBlock?: React.ReactNode;
        isFooterVisible?: boolean;
        isSignUp?: boolean;
        showDetails?: boolean;
    }>
> = ({ bottomBlock, isFooterVisible = true, isSignUp = false, showDetails = false, children }) => {
    const isMobile = useIsMobile();
    // Add a class login page to body only on mount and remove it on unmount
    useEffect(() => {
        document.body.classList.add('login-page');
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);

    return (
        <ExternalContainer $isMobile={isMobile}>
            <InternalContainer>
                <LandingContainer>
                    <Logo>
                        <LogoZakeke />
                    </Logo>

                    <LandingTitle>Join the</LandingTitle>
                    <LandingSubtitle>Visual Commerce Revolution</LandingSubtitle>

                    <ListContainer>
                        <ListItem>
                            <ListItemIcon>
                                <AwardSolid />
                            </ListItemIcon>
                            <ListItemTitle>Visual Customization</ListItemTitle>
                            <ListItemDescription>Set infinite customization options showing effects of various printing techniques</ListItemDescription>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CogSolid />
                            </ListItemIcon>
                            <ListItemTitle>Sales Channels</ListItemTitle>
                            <ListItemDescription>Connect and manage multiple e-commerce channels to your Zakeke account</ListItemDescription>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CrownSolid />
                            </ListItemIcon>
                            <ListItemTitle>POD</ListItemTitle>
                            <ListItemDescription>Sell customizable products from your favorite third-party catalogs</ListItemDescription>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <DumpsterSolid />
                            </ListItemIcon>
                            <ListItemTitle>3D Product Configurator</ListItemTitle>
                            <ListItemDescription>Create dynamic made-to-order products in 3D & get custom quotes</ListItemDescription>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <GlassesSolid />
                            </ListItemIcon>
                            <ListItemTitle>Virtual Try-On</ListItemTitle>
                            <ListItemDescription>Let customers virtually try a product on their body via their own mobile phone</ListItemDescription>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <IconsSolid />
                            </ListItemIcon>
                            <ListItemTitle>3D DAM & AR Viewer</ListItemTitle>
                            <ListItemDescription>Create, store, share 3D asset, get quotes for 3D models, embed them everywhere</ListItemDescription>
                        </ListItem>
                    </ListContainer>
                    <Customers>
                        <img src={UberEats} alt='UberEats' />
                        <img src={Clipper} alt='Clipper' />
                        <img src={Nau} alt='Nau' />
                        <img src={Bauli} alt='Bauli' />
                        <img src={Testoni} alt='Testoni' />
                    </Customers>
                </LandingContainer>
            </InternalContainer>
            <RightColumn>
                <FormContainer $signUp={isSignUp} $showDetails={showDetails}>
                    <div>{children}</div>
                    {isFooterVisible && (
                        <Footer>
                            <li>
                                <Link href='https://zakeke.zendesk.com/hc/' target='_blank'>
                                    Help
                                </Link>
                            </li>
                            <li>
                                <Link href='https://www.zakeke.com/privacy-policy-platform/#privacy-policy' target='_blank'>
                                    Privacy
                                </Link>
                            </li>
                            <li>
                                <Link href='https://www.zakeke.com/privacy-policy-platform/#general-conditions' target='_blank'>
                                    Terms
                                </Link>
                            </li>
                        </Footer>
                    )}
                    {bottomBlock}
                </FormContainer>
            </RightColumn>
        </ExternalContainer>
    );
};
